/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/react'
import { Container } from 'react-grid-system'

import H1 from '../typography/H1'
import ImageResponsive from '../images/ImageResponsive'
import P from '../typography/P'
import { mq } from '../../theme'

interface Props {
  img: string
}

const AboutUsSection5: React.FC<Props> = (props) => {
  const { img } = props
  return (
    <div css={{ backgroundColor: 'white' }}>
      <Container>
        <div
          css={[
            mq('d-flex'),
            mq('col'),
            mq('text-center'),
            mq('flex-center'),
            { padding: '4em 0px' },
          ]}
        >
          <H1>Our Curated Collection</H1>
          <P css={{ maxWidth: '700px' }}>
            Browse our carefully curated selection of artworks and design items
            from the world’s best, including Paintings, Photography, Prints,
            Sculptures, Ceramics, Design Objects, Furniture, Lighting, and more!
          </P>
          <div css={{ margin: '4em 0px' }}>
            <ImageResponsive src={img || ''} alt={''} />
          </div>
        </div>
      </Container>
    </div>
  )
}

export default AboutUsSection5
